module.exports = __webpack_public_path__ + "img/uncontact.13021490.png";